





































import ProviderUtils, { ProviderCategory } from '@/utils/ProviderUtils';
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Object as () => Partial<ProviderCategory>,
    },
    mode: {
      type: String as () => 'create' | 'edit',
      required: true,
    },
    'error-messages': {
      type: Object as () => { [key: string]: string[] },
      default: () => ({}),
    },
  },

  computed: {
    internal: {
      get(): Partial<ProviderCategory> {
        return this.value || ProviderUtils.category.generateDefault();
      },
      set(val: Partial<ProviderCategory>) {
        this.$emit('input', val);
      },
    },
  },
});
